import { PaymentService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { billingKeys } from './billingKeys';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.paymentIntent>>;

export const createFetchPaymentIntentQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ paymentIntentId }], signal }: TParams) =>
    call(() => cancelOnSignal(PaymentService.getPaymentIntent({ id: paymentIntentId }), signal));
